import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import {
  ProductAttributes,
  UpdateProductAttributesPayload
} from "../../recommendation.types";

export const requestUpdateProductAttributes = async ({
  id,
  payload
}: {
  id: string;
  payload: UpdateProductAttributesPayload;
}): Promise<ProductAttributes> => {
  return await instance.patch(
    `${ApiRoutesRecommendation.Enrichment}/${encodeURIComponent(id)}`,
    payload
  );
};
